import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Content from 'Settings/Content';

import { getService } from 'reducers/service';
import { handleError } from 'reducers/ErrorReducer';
import { notify } from 'reducers/NotifierReducer';

import { gridStyle } from 'utils/formStyles';
import { XGrid } from '@material-ui/x-grid';
import { Fab } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import { showCitationCourt } from 'reducers/DialogsReducer';
import QuickFilter from 'components/QuickFilter';
import CheckIcon from '@material-ui/icons/Check';
import { getInitials } from 'utils/functions';

import options from 'components/EventTypeIcons';
import { showAddEditEventTypeInitials } from 'reducers/DialogsReducer';

const useStyles = makeStyles(theme => ({
  item: {
    ...gridStyle(200, 800),
  },
  list: {
    width: '100%',
    boxSizing: 'border-box',
    height: `calc(100vh - 235px)`,
  },
  wrap: {
    padding: theme.spacing(2),
    '& > h5': {
      marginBottom: 20,
    },
  },
  actions: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 0, 2),
    textAlign: 'right',
    '& button': {
      marginLeft: theme.spacing(1),
    },
  },
}));
const bool = params => (params.value ? <CheckIcon /> : <span></span>);
export const colorRender = params =>
  params.value ? (
    <span
      style={{
        backgroundColor: params.value,
        border: `2px solid #fff`,
        borderRadius: 20,
        display: 'inline-block',
        minWidth: '1.5rem',
        minHeight: '1.5rem',
        boxSizing: 'border-box',
      }}
    />
  ) : (
    <span></span>
  );
const iconRender = params => {
  const Icon = options[params.value];
  return Icon ? <Icon /> : <span></span>;
};
const columnsItems = [
  { field: 'Code', headerName: 'Event Type', width: 250 },
  { field: 'Initial', headerName: 'Initials', width: 200 },
  { field: 'Description', headerName: 'Description', width: 300 },
  { field: 'Custom', headerName: 'Custom', width: 150, format: 'bool', renderCell: bool },
  { field: 'Icon', headerName: 'Icon', width: 150, renderCell: iconRender },

  { field: 'IsActive', headerName: 'Active', width: 150, renderCell: bool },
  { field: 'Priority', headerName: 'Priority', width: 150 },
  { field: 'AgencyType', headerName: 'Agency Type', width: 150 },
];

function EventTypeInitials(props) {
  const { dictionary, addEditEventTypeInitials, wsClient } = props;

  const classes = useStyles();
  const service = getService('settings-event-type-initials');
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [selection, setSelection] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [open, setOpen] = useState(false);
  const [eventTypes, setEventTypes] = useState([]);
  const [editableRow, setEditableRow] = useState({});
  const dispatch = useDispatch();
  useEffect(() => {
    if (wsClient) {
      const fetchCodes = async () => {
        const service = getService('codecadtypes');
        const data = await service.find({
          query: {
            IsDeleted: false,

            $limit: 0,
            $sort: {
              Code: 1,
            },
          },
        });

        renderList(data.data);
      };
      fetchCodes();
    }
  }, [wsClient, addEditEventTypeInitials]);

  const renderList = async CallTypes => {
    const evTypes = CallTypes.map(row => {
      return {
        ...row,
        Initial: getInitials(row.Code, row.Description),
        Custom: false,
        Icon: 0,
        id: row.Code,
      };
    });

    const eventTypes = await updateList(evTypes);
    setRows(eventTypes);
    setLoaded(true);
  };

  const updateList = async evTypes => {
    const fetchedInitials = await service.find();

    fetchedInitials.forEach(f => {
      evTypes.forEach(et => {
        et.IsActive = et.isActive || false;
        if (et.Code === f.CDRKey && (et.Initial !== f.ValueString || et.Icon !== f.ValueNumeric)) {
          et.Initial = f.ValueString;
          et.Icon = f.ValueNumeric;

          et.Custom = true;
        }
      });
    });
    return evTypes;
  };

  const handleSelectChange = ({ selectionModel }) => {
    setSelection(selectionModel);
  };

  const onClickAdd = () => {
    dispatch(showAddEditEventTypeInitials({ type: 'add' }));
    setOpen(true);
  };
  const onClickEdit = () => {
    const obj = rows.find(row => row.id == selection[0]);
    // console.log('obj', obj, selection);
    dispatch(showAddEditEventTypeInitials({ type: 'edit', info: obj }));

    setOpen(true);
  };
  const onClickDelete = async () => {
    if (!window.confirm('Do you want to delete this event type?')) return;
    try {
      await service.remove({ id: selection[0], type: 'eventType' });

      const newRows = rows.filter(el => el.id !== selection[0]);
      setRows(newRows);
      props.notify('Deleted', 'warning');
      setSelection([]);
    } catch (err) {
      props.handleError(err, 'Error deleting event type');
    }
  };
  const renderActions = () => {
    const disabled = selection.length === 0;
    const selected = rows.find(a => a.id === selection[0]);
    //const dltDisabled = selected?.Icon === 0;
    return (
      <div className={classes.actions}>
        <div>
          <QuickFilter rows={rows} columns={columnsItems} setFilteredRows={setFilteredRows} />
        </div>
        <div>
          <Fab size="small" color="secondary" onClick={onClickAdd}>
            <AddIcon />
          </Fab>
          <Fab size="small" color="secondary" onClick={onClickEdit} disabled={disabled}>
            <EditIcon />
          </Fab>
          <Fab size="small" color="secondary" onClick={onClickDelete} disabled={disabled}>
            <DeleteIcon />
          </Fab>
        </div>
      </div>
    );
  };
  return (
    <Content>
      <div className="m-4">
        <h4>Event Type Initials and Icons</h4>
        {renderActions()}
        <div className={classes.list}>
          <XGrid
            columns={columnsItems}
            rows={filteredRows}
            loading={!loaded}
            rowHeight={38}
            getRowId={row => row.id}
            // checkboxSelection
            onSelectionModelChange={handleSelectChange}
          />
        </div>
      </div>
    </Content>
  );
}

const mapStateToProps = state => {
  return {
    wsClient: state.websocket,
    dictionary: state.config.dictionary,
    addEditEventTypeInitials: state.dialogs.addEditEventTypeInitials,
  };
};

export default connect(mapStateToProps, {
  handleError,
  notify,
})(EventTypeInitials);
